/* 🤖 this file was generated by svg-to-ts */
export const matIconSecurityUpdate: {
  name: 'security-update';
  data: string;
} = {
  name: 'security-update',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M17 1.01 7 1c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM17 21H7v-1h10v1zm0-3H7V6h10v12zM7 4V3h10v1H7zm9 8-4 4-4-4 1.41-1.41L11 12.17V8h2v4.17l1.59-1.59L16 12z"/></svg>`
};
